import React from "react";
import styled from "styled-components";
import RichTextRender from "../../../../components/RichTextRender/RichTextRender";
import { useSelector } from "react-redux";
import { Collapse, List } from "antd";
import Title from "antd/es/typography/Title";
import Text from "antd/es/typography/Text";
import { useTranslation } from "react-i18next";
import PromoItem from "../../../ShopPage/components/PromoItem/PromoItem";
import useIsMobile from "../../../../hooks/useIsMobile";
import { trackEvent } from "../../../../services/mixpanel";
import { getSupplierData } from "../../../../Redux/Selectors/appConfigSelector";
import Disclaimer from "../../../../components/Disclaimer/Disclaimer";
import DropdownButton from "../../components/DropdownButton/DropdownButton";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: start;
  justify-content: start;
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  align-items: start;
  width: 100%;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const ProductContentContainer = ({
  image,
  title,
  description,
  passengerId,
  closeModal,
  subtitle,
  promo,
  category,
  price,
  periodType,
  currency,
  id,
  viewButtonAddPassenger = false,
  passengersMenu,
  rowId,
  arrayCategories,
  activePassenger,
}) => {
  const supplierData = useSelector(getSupplierData);
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const renderPromos = () => {
    return (
      <List
        header={<Text strong>{t("shop:promotions.listHeader")}</Text>}
        footer={
          <Text type="secondary" style={{ fontSize: 12 }}>
            {t("shop:promotions.listFooter")}
          </Text>
        }
        dataSource={promo}
        renderItem={(item) => (
          <List.Item>
            <PromoItem
              key={id}
              amount={item.amount}
              type={item.type}
              periodAmount={item.periodQuantity}
              operation={item.operation}
              periodType={periodType}
              currency={currency}
              price={price}
            />
          </List.Item>
        )}
      />
    );
  };

  return (
    <Container>
      <Content>
        <Wrapper>
          <img
            src={image}
            alt={`Alquilar ${title} - ${supplierData?.name}`}
            size="large"
            style={{
              height: isMobile ? 60 : 250,
              width: isMobile ? 60 : 250,
              minWidth: isMobile ? 60 : 250,
              objectFit: "contain",
            }}
            shape="square"
          />
          <div>
            <Title
              type="secondary"
              level={5}
              style={{ marginTop: 0, fontSize: 14 }}
            >
              {subtitle}
            </Title>
            {description !== "null" && (
              <RichTextRender content={description} style={{ fontSize: 12 }} />
            )}
          </div>
        </Wrapper>
      </Content>
      <DropdownButton
        closeModal={closeModal}
        trackEvent={trackEvent}
        productId={id}
        title={title}
        category={category}
        supplierData={supplierData}
        passengersMenu={passengersMenu}
        passengerId={passengerId}
        rowId={rowId}
        arrayCategories={arrayCategories}
        activePassenger={activePassenger}
        viewButtonAddPassenger={viewButtonAddPassenger}
      />

      <Disclaimer
        text={t("shop:disclaimerImageProduct")}
        bordered={false}
        size="small"
      />
      {promo.length > 0 && (
        <Collapse style={{ width: "100%" }}>
          <Collapse.Panel header={t("shop:promotions.pickPromo")}>
            {renderPromos()}
          </Collapse.Panel>
        </Collapse>
      )}
    </Container>
  );
};

export default ProductContentContainer;
